<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item label="">
        <el-select v-model="search.ad_type" placeholder="请选择类型" clearable>
          <el-option :label="item.title" :value="item.id" v-for="(item,index) in adTypeList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addGroup()">添加</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="delGroup()">删除</el-button>
    </div>
    <div class="notice-tip mg-bt-10">
      <div class="mg-bt-5">温馨提示：</div>
      <div>1、开屏广告如果多张，则为轮播图播放</div>
      <div>2、弹框广告如果多张，则弹出最新的一张</div>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          align="center"
          width="55">
      </el-table-column>
      <el-table-column
          prop="title"
          label="名称">
      </el-table-column>
      <el-table-column
          prop="ad_type"
          label="类型"
          align="left"
          width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.ad_type==1">开屏广告</div>
          <div v-if="scope.row.ad_type==2">弹窗广告</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="img"
          label="广告图"
          min-width="250">
        <template slot-scope="scope">
          <div class="member-box">
            <img :src="scope.row.img ? scope.row.img : source_domain + '/images/head.png'" style="border-radius: 5px;" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="start_time"
          label="活动时间"
          align="center"
          width="220">
        <template slot-scope="scope">
          <div>{{scope.row.start_time}}</div>
          <div style="line-height: 2px;">~</div>
          <div>{{scope.row.end_time}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-switch
              :value="scope.row.status==1?'1':'0'"
              @change="shenheGroup(scope.row)"
              active-value="1"
              inactive-value="2"
              active-text="关闭"
              inactive-text="开启">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="ordering"
          label="排序"
          align="center"
          width="150">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="150">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editGroup(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>
<script>

import variable from "@/utils/variable";

export default {
  components: {
  },
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      adTypeList: variable.adTypeList,
      search: {
        keywords: '',
        ad_type: '',
        current_page: 1,
        total: 0,
        limit: 10
      },
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        ad_type: that.search.ad_type
      }
      this.$api.marking.adIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    addGroup() {
      this.$router.push({name: 'marking_ad_add'})
    },
    editGroup(item) {
      this.$router.push({name: 'marking_ad_add', query: {id: item.id}})
    },
    delGroup() {
      var that = this
      var sel = this.$refs.rfTable.selection
      if (sel.length < 1) {
        that.tips('请选择删除项')
        return false
      }
      var ids = []
      sel.forEach(function (item) {
        ids.push(item.id)
      })
      this.$confirm('确认要删除这些数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.marking.adDel({ids: ids}, function (res) {
          if (res.errcode == 0) {
            that.success('删除成功')
            that.getList()
          } else {
            that.fail(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    shenheGroup(item) {
      this.$api.marking.adShenhe({id: item.id, status: item.status == 1 ? 0 : 1}, res => {
        if (res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
